/* eslint-disable */
import React from 'react';
import type { PracticeGridCardIconRender } from './cardIcons';
import { PSA_PRACTICE_GRID_ICONS, TPV_PRACTICE_GRID_ICONS } from './cardIcons';
import './index.less';
import './index.en.less';

export type { PracticeGridCardIconRender } from './cardIcons';
export { PSA_PRACTICE_GRID_ICONS, TPV_PRACTICE_GRID_ICONS } from './cardIcons';

export type PracticeGridCardsVariant = 'psa' | 'tpv';

export interface IPracticeGridCardItem {
  title?: string;
  desc?: string;
  text?: string;
}

export interface IPracticeGridCardsProps {
  description?: string;
  items?: (IPracticeGridCardItem | string)[];
  icons?: any[];
  variant?: PracticeGridCardsVariant;
  id?: string;
  className?: string;
}

const TOP_ROW_COUNT = 3;

const VARIANT_ICONS: Record<
  PracticeGridCardsVariant,
  PracticeGridCardIconRender[]
> = {
  psa: PSA_PRACTICE_GRID_ICONS,
  tpv: TPV_PRACTICE_GRID_ICONS,
};

const PracticeGridCards: React.FunctionComponent<IPracticeGridCardsProps> = ({
  description,
  items = [],
  icons,
  variant = 'psa',
  id,
  className,
}) => {
  if (!items.length && !description) return null;

  const iconSet = icons ?? VARIANT_ICONS[variant];
  const normalizedItems = items.map((item) =>
    typeof item === 'string' ? { desc: item } : item
  );
  const topRowItems = normalizedItems.slice(0, TOP_ROW_COUNT);
  const bottomRowItems = normalizedItems.slice(TOP_ROW_COUNT);

  const renderCard = (item: IPracticeGridCardItem, index: number) => {
    const Icon = iconSet[index % iconSet.length];
    const content = item.desc ?? item.text ?? '';

    return (
      <div
        key={index}
        className={[
          'practice-grid-card',
          `practice-grid-card--${variant}`,
        ].join(' ')}
      >
        <div className="practice-grid-card-header">
          {item.title ? (
            <span className="practice-grid-card-title">{item.title}</span>
          ) : null}
          <div className="practice-grid-card-icon">{Icon()}</div>
        </div>
        <div className="practice-grid-card-body">
          {content ? (
            <p className="practice-grid-card-text">{content}</p>
          ) : null}
        </div>
      </div>
    );
  };

  return (
    <div
      className={`practice-grid-cards practice-grid-cards--${variant}${
        className ? ` ${className}` : ''
      }`}
      id={id}
    >
      {description ? (
        <p className="practice-grid-cards-desc">{description}</p>
      ) : null}
      {topRowItems.length > 0 ? (
        <div className="practice-grid-cards-row practice-grid-cards-row--top">
          {topRowItems.map((item, index) => renderCard(item, index))}
        </div>
      ) : null}
      {bottomRowItems.length > 0 ? (
        <div className="practice-grid-cards-row practice-grid-cards-row--bottom">
          {bottomRowItems.map((item, index) =>
            renderCard(item, index + TOP_ROW_COUNT)
          )}
        </div>
      ) : null}
    </div>
  );
};

export default React.memo(PracticeGridCards);
